export default {
  MONITORAR (state, info) {
      state.monitorar = info
  },
}